/**
 * Investment profile types shared across member-app and grove-app.
 */

export enum IncomeSourceStability {
    VERY_STABLE = 'VERY_STABLE',
    STABLE = 'STABLE',
    SOMEWHAT_STABLE = 'SOMEWHAT_STABLE',
    VERY_UNSTABLE = 'VERY_UNSTABLE',
    UNSTABLE = 'UNSTABLE',
}

export enum InvestmentPortfolioLoss {
    BUY_MORE = 'BUY_MORE',
    HOLD_NOTHING = 'HOLD_NOTHING',
    SELL_PORTION = 'SELL_PORTION',
    SELL_EVERYTHING = 'SELL_EVERYTHING',
}

export enum InvestmentReturnPreference {
    STRONGLY_AGREE = 'STRONGLY_AGREE',
    AGREE = 'AGREE',
    SOMEWHAT_AGREE = 'SOMEWHAT_AGREE',
    DISAGREE = 'DISAGREE',
    STRONGLY_DISAGREE = 'STRONGLY_DISAGREE',
}

export enum AccountFluctuationComfortability {
    VERY_COMFORTABLE = 'VERY_COMFORTABLE',
    COMFORTABLE = 'COMFORTABLE',
    SOMEWHAT_COMFORTABLE = 'SOMEWHAT_COMFORTABLE',
    UNCOMFORTABLE = 'UNCOMFORTABLE',
    VERY_UNCOMFORTABLE = 'VERY_UNCOMFORTABLE',
}

export enum NetWorth {
    BETWEEN_0_50000 = 'BETWEEN_0_50000',
    BETWEEN_50000_100000 = 'BETWEEN_50000_100000',
    BETWEEN_100000_250000 = 'BETWEEN_100000_250000',
    PLUS_250000 = 'PLUS_250000',
}

export enum YesNo {
    YES = 'YES',
    NO = 'NO',
}

export enum ResidencyStatus {
    PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
    TEMPORARY_RESIDENT = 'TEMPORARY_RESIDENT',
    NONRESIDENT = 'NONRESIDENT',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum ManualInterventionStatus {
    NONE_REQUIRED = 'NONE_REQUIRED',
    REQUIRED = 'REQUIRED',
    CLEARED = 'CLEARED',
}

export type Finra3210MimeType =
    | 'application/pdf'
    | 'image/jpeg'
    | 'image/png'
    | 'image/tiff';

export interface Finra3210Payload {
    firmName: string;
    fileContentBase64: string;
    mimeType: Finra3210MimeType;
}

export interface UserInvestmentProfile {
    userId: string;
    incomeSourceStability?: IncomeSourceStability;
    investmentPortfolioLoss?: InvestmentPortfolioLoss;
    investmentReturnPreference?: InvestmentReturnPreference;
    accountFluctuationComfortability?: AccountFluctuationComfortability;
    citizenship?: string;
    residency?: ResidencyStatus;
    netWorth?: NetWorth;
    shareholderOfPublicCompany?: YesNo;
    stockExchangeMember?: YesNo;
    boardOfPublicCompany?: YesNo;
    politicalExposure?: YesNo;
    backupWithholding?: YesNo;
    manualInterventionStatus?: ManualInterventionStatus;
    createdAt?: Date;
    updatedAt?: Date;
}

export type UpsertUserInvestmentProfileBody = Partial<
    Pick<
        UserInvestmentProfile,
        | 'incomeSourceStability'
        | 'investmentPortfolioLoss'
        | 'investmentReturnPreference'
        | 'accountFluctuationComfortability'
        | 'citizenship'
        | 'residency'
        | 'netWorth'
        | 'shareholderOfPublicCompany'
        | 'stockExchangeMember'
        | 'boardOfPublicCompany'
        | 'politicalExposure'
        | 'backupWithholding'
    >
>;

export interface TrustedContact {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    createdAt: string;
    updatedAt: string;
}

export interface CreateTrustedContactDto {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}
